import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

/**
 * Deletes a company account.
 *
 * @param companyAccountId - The company account ID to delete.
 * @param options - Additional request options.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company-Account/operation/delete_company_account_vadmin_company_accounts__company_account_id__delete
 */
export async function deleteCompanyAccount(
  companyAccountId: UUID,
  options?: KyRequestOptions,
): Promise<void> {
  // A successful deletion returns 204 No Content, so there is no response body to validate.
  await vestigasApi.delete(ENDPOINT.COMPANY.ACCOUNT.DELETE(companyAccountId), {
    ...options,
    retry: 0,
    timeout: false,
  });
}
